export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}assistant/assistant`;
    return $resource(url, null, {
        help: {
            method: 'POST',
            url: `${url}/help`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/Assistant/index.js